class OrderController {
    static $inject = ["$q", "$location", "$sce", "stToast", "tpsrService", "reportService"];

    constructor($q, $location, $sce, stToast, tpsrService, reportService) {
        this.$q = $q;
        this.$location = $location;
        this.$sce = $sce;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.reportService = reportService;

        this.ref = null;
        this.showReturnCreated = false;
        this.latestReturnId = null;

        this.user = null;
        this.order = {
            lines: []
        }
        this.returns = [];
    }

    $onInit() {
        this.isAdmin = this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin;
        this.isAdminOrManager = this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin || this.tpsr.user.is_manager;

        const search = this.$location.search();
        if (search && search.ref) {
            if (search.ref) {
                this.ref = search.ref;
                if (this.ref === "return-created") {
                    this.showReturnCreated = true;
                    this.latestReturnId = search.rid;
                }
            }
        }

        // Edit Order
        if (this.orderId)
            return this.$q.all(
                this._loadOrder(this.orderId).then(o => this._loadUser(o.user_id)),
                this._loadReturns(this.orderId, null)
            );


        // Create Order
        let user_id = this.tpsr.user.user_id;
        if (this.userId)
            if (this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin || this.tpsr.user.is_manager || this.tpsr.is_approver)
                user_id = this.userId;

        return this._loadUser(user_id).then(this._loadItems);
    }

    showApproveReject = order => {
        if (!this.tpsr.user.is_approver)
            return false;

        if (!(order.order_status === 'PND' || order.order_status === 'REJ'))
            return false;

        if (this.tpsr.user.user_id === order.create_user)
            return false;

        return true;
    };

    showCreateReturn = () => {
        if (!this.order || !this.order.shipments)
            return false;

        if (this.order.shipments.length === 0)
            return false;

        if (this.tpsr.user.user_id === this.order.user_id)
            return true;

        if (this.tpsr.user.is_npc_admin || this.tpsr.user.is_admin)
            return true;

        return false;
    };

    getTrackingLinks = details => {
        const hrefs = details.map(d => `<a href="${d.tracking_url}" target="_blank">${d.tracking_number}</a>`);
        return this.$sce.trustAsHtml(`<ul class="list-unstyled"><li>` + hrefs.join(`</li><li>`) + `</li></ul>`);
    }

    createOrderClicked = () => {
        const request = {
            user_id: this.user.user_id,
            is_replacement_bit: false,	
            is_replacement_for_failed_to_deliver_bit: false,
            replacement_for_order_id: null,
            lines: []
        };
        this.order.lines.forEach(item => {
            if (item.quantity > 0) {
                request.lines.push({
                    PIMS_item_id: item.PIMS_item_id,	
                    Unit_Of_Measure: item.uom,
                    quantity: item.quantity
                });
            }
        });

        return this.tpsr.createOrder(request).then(result => {
            if (result.success) {
                this.toast.success("Order Created", `Order created.`)
                this.$location.url(`/users/${this.user.user_id}/orders`);
            }
        });
    };

    closeAlert = () => {
        this.showReturnCreated = false;
    };

    approveClicked = order => {
        return this.tpsr.approveOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Approved", `Order approved.`)
                this._loadOrder(order.order_id);
            }
        });
    };

    rejectClicked = order => {
        return this.tpsr.rejectOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Rejected", `Order rejected.`)
                this._loadOrder(order.order_id);
            }
        });
    };

    cancelClicked = () => {
        this.$location.url(`/users/${this.user.user_id}/orders`);
    };

    returnToPendingClicked = () => {
        this.$location.url(`/managers/${this.tpsr.user.user_id}/pending-orders`);
    };

    orderReturnsClicked = shipment => {
        this.$location.url(`/orders/${this.order.order_id}/returns`);
    };

    orderReplaceLostShipmentClicked = shipment => {
        this.$location.url(`/orders/${this.order.order_id}/replace-lost-shipment/${shipment.PIMS_order_id}/`);
    };

    deleteClicked = order => {
        return this.tpsr.deleteOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Deleted", `Order deleted.`)
                this.$location.url(`/users/${this.user.user_id}/orders`);
            }
        });
    };

    packingSlipClicked = shipment => {
        return this.reportService.getPackListRpt(shipment.PIMS_order_id);
    };

    downloadLabelClicked = order => {
        return this.reportService.getShippingLabel(order);
    };

    downloadLatestLabelClicked = () => {
        const returnOrder = this.returns.find(r => r.return_id === this.latestReturnId);
        return this.reportService.getShippingLabel(returnOrder);
    };

    isValidItem = item => {
        if (this.isAdmin)
            return true; // Admin does not have max quantity limit.

        const maxQty = parseInt(item.max_order_qty || 0);
        const qty = parseInt(item.quantity || 0);
        if (maxQty > 0 && qty > maxQty)
            return false;

        return true;
    };

    canSave = () => {
        let can = true;
        let tot = 0;
        this.order.lines.forEach(line => {
            if (!this.isValidItem(line))
                can = false;
            tot += parseInt(line.quantity || 0);
        });
        return can && tot > 0;
    };

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id).then(result => {
            this.user = result;
        });
    };

    _loadOrder = order_id => {
        return this.tpsr.getOrder(order_id).then(result => {
            this.order = result;
            return result;
        });
    };

    _loadItems = () => {
        return this.tpsr.getItems(this.user.PIMS_customer_id).then(result => {
            let lines = result.filter(r => !r.is_disabled);
            if (!this.isAdmin)
                lines = lines.filter(r => r.max_order_qty !== 0);
            lines.forEach(i => {
                i.quantity = 0;
            });
            this.order.lines = lines;
        });
    };

    _loadReturns = (order_id, user_id) => {
        return this.tpsr.getReturns(order_id, user_id).then(result => {
            this.returns = result.orders;
            this.returns.forEach(r => {
                r.total_return_quantity = r.lines.reduce((t, l) => t + l.return_quantity, 0);
                r.total_replace_quantity = r.lines.reduce((t, l) => t + l.replace_quantity, 0);
                r.want_replacement = r.total_replace_quantity > 0;
            });
        });
    };
}

angular
    .module("app")
    .component("order", { // order
        bindings: {
            orderId: "<",
            userId: "<"
        },
        templateUrl: "src/app/order/order.html",
        controller: OrderController
    });
